import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="footer-first">
                <div className="footer-contact">
                  <Link to="tel:+919910965878"><img src="/assets/images/call.webp" alt="phone" /> +91 99109 65878 </Link>
                  <Link to="mailto:info@nativesutra.com"><img src="/assets/images/email.webp" alt="mail" /> info@nativesutra.com  </Link>
                </div>
                <ul className="footer-social">
                  <li><Link to={"https://www.instagram.com/nativesutra/"} target="_blank">   <i className="fa-brands fa-instagram"></i>  </Link> </li>
                  <li><Link to={"https://www.facebook.com/nativesutra"} target="_blank">   <i className="fa-brands fa-facebook-f"></i>  </Link> </li>
                  <li><Link to={"https://in.pinterest.com/nativesutra/"} target="_blank"> <i className="fa-brands fa-pinterest-p"></i> </Link> </li>

                  {/* <li><Link to={"https://www.linkedin.com/company/nativesutra/"} target="_blank">   <i className="fa-brands fa-linkedin-in"></i>  </Link> </li>
                  <li><Link to={"https://www.youtube.com/@nativesutra3728"} target="_blank"> <i className="fa-brands fa-youtube"></i> </Link>  </li> */}
                </ul>
              </div>
              <img src="/assets/images/footer-logo.webp" className="footer-logo wow animate__animated animate__fadeInUp" loading="lazy" alt="download" data-wow-duration="1.1s" data-wow-delay="0.1s" />
              <div className="footer-third">
                <p><span>©2026 NativeSutra.</span> All rights reserved.</p>

                <ul className="footer-otherlink">
                  <li><Link to="/disclaimer/">Disclaimers</Link> </li>
                  <li>|</li>
                  <li><Link to="/privacy-policy/">Privacy</Link>  </li>
                  <li>|</li>
                  <li><Link>Sitemap</Link> </li>
                </ul>

                {/* <p>Designed by <a href="https://www.88gravity.com" target="_blank" rel="noopener noreferrer">88gravity</a></p> */}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
